import React from 'react';
import { Modal, Form, Input, Button } from 'antd';
import { useTranslation } from 'react-i18next';

interface EmailConfigurationTestModalProps {
  visible: boolean;
  onCancel: () => void;
  onSendTestEmail: (email: string) => void;
  loading: boolean;
}

const EmailConfigurationTestModal: React.FC<EmailConfigurationTestModalProps> = ({
  visible,
  onCancel,
  onSendTestEmail,
  loading,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const handleSendTestEmail = async () => {
    try {
      const values = await form.validateFields();
      onSendTestEmail(values.email);
    } catch (error) {
      // Form validation error - do nothing, form will show the error
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title={t('emailConfiguration.test.title')}
      open={visible}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          {t('common.cancel')}
        </Button>,
        <Button key="send" type="primary" loading={loading} onClick={handleSendTestEmail}>
          {t('emailConfiguration.test.sendButton')}
        </Button>,
      ]}
      width={400}
    >
      <Form form={form} layout="vertical" requiredMark={false}>
        <Form.Item
          name="email"
          label={t('emailConfiguration.test.emailLabel')}
          rules={[
            { required: true, message: t('emailConfiguration.test.emailRequired') },
            { type: 'email', message: t('emailConfiguration.test.emailInvalid') },
          ]}
        >
          <Input placeholder={t('emailConfiguration.test.emailPlaceholder')} type="email" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EmailConfigurationTestModal;
